/* jshint camelcase:false */
'use strict';

import $ from 'jquery';

function checkNavScroll(navbar, navtop) {
  if ($(window).scrollTop() > navtop) {
    navbar.addClass('ofs-PageNav--is-floating');
  } else {
    navbar.removeClass('ofs-PageNav--is-floating');
  }
}

function setNavSpacerHeight(pagenav, pagenavspace) {
  pagenavspace.css('height', pagenav.height() + 'px');
}

export default function navigation() {
  // Set the container or the navbar to be same height as navbar as when
  // we make it static we don't want the page size to change as it will
  // mess up smooth scrolling
  var $pageNav = $('#page_navigation');
  var $pageNavSpace = $('#page_navigation_spacer');

  setNavSpacerHeight($pageNav, $pageNavSpace);
  $(window).resize(function () {
    setNavSpacerHeight($pageNav, $pageNavSpace);
  });


  // When window scrolls (or page loads) decide whether to make the
  // navbar fixed or static
  var navbar = $('#page_navigation_container');
  var navtop = navbar.offset().top;

  checkNavScroll(navbar, navtop);
  $(window).scroll(function () {
    checkNavScroll(navbar, navtop);
  });

  // Set correct background for selected element in navbar
  $('#page_navigation li a').click(function (e) {
    var el = $(e.target);
    window.setTimeout(function () {
      el.parent().parent().find('a').removeClass('ofs-PageNav__Link--selected');
      el.addClass('ofs-PageNav__Link--selected');
    }, 600);
  });

  // Smooth scroll to the internal links, leaving 50px space above header so the
  // navbar doesn't cover the titles or other content
  $('#page_navigation a[href^="#"]').click(function (event) {
    event.preventDefault();
    var dest = 0;
    if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
      dest = $(document).height() - $(window).height();
    } else {
      dest = $(this.hash).offset().top - $pageNav.height() - 50;
    }
    $('html, body').animate({scrollTop: dest}, 500, 'swing');
  });

  $('#page_navigation li a[href^="#"]').each(function () {
    var link = this.href;
    link = link.split('#')[1];
    $('#' + link).waypoint(function () {
      $('#page_navigation').find('a').removeClass('ofs-PageNav__Link--selected');
      $('#page_navigation').find('a[href^="#' + link + '"]').addClass('ofs-PageNav__Link--selected');
    }, {offset: 70});
  });
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/navigation.js
 **/